import {
  GET_CERTIFICATE_LIST_FOR_DROPDOWN,
  GET_CERTIFICATE_LIST_FOR_DROPDOWN_FAILED,
  GET_CERTIFICATE_LIST_FOR_DROPDOWN_SUCCESS,
  GET_COURSE_SYLLABUS_RESOURCE,
  GET_COURSE_SYLLABUS_RESOURCE_FAILED,
  GET_COURSE_SYLLABUS_RESOURCE_SUCCESS,
  GET_COURSE_USER_LIST_REQUEST,
  GET_COURSE_USER_LIST_SUCCESS,
  GET_DISCUSSION_FORUM_LIST,
  GET_DISCUSSION_FORUM_LIST_SUCCESS,
  GET_LESSON_DROPBOX_LIST,
  GET_LESSON_DROPBOX_LIST_SUCCESS,
  GET_LESSON_POST_LIST,
  GET_LESSON_POST_LIST_SUCCESS,
  GET_LESSON_SURVEY_LIST,
  GET_LESSON_SURVEY_LIST_SUCCESS,
  GET_LESSON_TEST_LIST,
  GET_LESSON_TEST_LIST_SUCCESS,
  GET_RESOURCE_FILE_REQUEST,
  GET_RESOURCE_FILE_REQUEST_SUCCESS,
  GET_RESOURCE_USER_REQUEST,
  GET_RESOURCE_USER_REQUEST_SUCCESS,
} from "../constants";

export const initialState = {
  courseUsers: undefined,
  courseUsersLoading: false,
  resources: undefined,
  resourcesLoading: false,
  resourceFile: undefined,
  resourceFileLoading: false,
  discussionForum: undefined,
  discussionForumLoading: false,
  dropBoxList: undefined,
  dropBoxListLoading: false,
  surveyList: undefined,
  surveyListLoading: false,
  testList: undefined,
  testListLoading: false,
  postList: undefined,
  postListLoading: false,
  certificateList: undefined,
  certificateListLoding: undefined,
  courseSyllabusResource: undefined,
  courseSyllabusResourceLoading: false,
};
export const DropdownDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSE_USER_LIST_REQUEST: {
      return {
        ...state,
        courseUsersLoading: !state.courseUsersLoading,
      };
    }
    case GET_COURSE_USER_LIST_SUCCESS:
      return {
        ...state,
        courseUsers: action.payload,
      };

    case GET_RESOURCE_USER_REQUEST: {
      return {
        ...state,
        resourcesLoading: !state.resourcesLoading,
      };
    }
    case GET_RESOURCE_USER_REQUEST_SUCCESS: {
      return {
        ...state,
        resources: action.payload,
      };
    }
    case GET_RESOURCE_FILE_REQUEST: {
      return {
        ...state,
        resourceFileLoading: !state.resourceFileLoading,
      };
    }
    case GET_RESOURCE_FILE_REQUEST_SUCCESS: {
      return {
        ...state,
        resourceFile: action.payload,
      };
    }
    case GET_DISCUSSION_FORUM_LIST: {
      return {
        ...state,
        discussionForumLoading: !state.discussionForumLoading,
      };
    }
    case GET_DISCUSSION_FORUM_LIST_SUCCESS: {
      return {
        ...state,
        discussionForum: action.payload,
      };
    }

    case GET_LESSON_DROPBOX_LIST: {
      return {
        ...state,
        dropBoxListLoading: !state.dropBoxListLoading,
      };
    }
    case GET_LESSON_DROPBOX_LIST_SUCCESS: {
      return {
        ...state,
        dropBoxList: action.payload,
      };
    }
    case GET_LESSON_SURVEY_LIST: {
      return {
        ...state,
        surveyListLoading: !state.surveyListLoading,
      };
    }
    case GET_LESSON_SURVEY_LIST_SUCCESS: {
      return {
        ...state,
        surveyList: action.payload,
      };
    }
    case GET_LESSON_TEST_LIST: {
      return {
        ...state,
        testListLoading: !state.testListLoading,
      };
    }
    case GET_LESSON_TEST_LIST_SUCCESS: {
      return {
        ...state,
        testList: action.payload,
      };
    }
    case GET_LESSON_POST_LIST: {
      return {
        ...state,
        postListLoading: !state.postListLoading,
      };
    }
    case GET_LESSON_POST_LIST_SUCCESS: {
      return {
        ...state,
        postList: action.payload,
      };
    }
    case GET_CERTIFICATE_LIST_FOR_DROPDOWN: {
      return {
        ...state,
        certificateListLoding: !state.certificateListLoding,
      };
    }
    case GET_CERTIFICATE_LIST_FOR_DROPDOWN_SUCCESS: {
      return {
        ...state,
        certificateList: action.payload,
        certificateListLoding: !state.certificateListLoding,
      };
    }
    case GET_CERTIFICATE_LIST_FOR_DROPDOWN_FAILED: {
      return {
        ...state,
        certificateList: [],
        certificateListLoding: !state.certificateListLoding,
      };
    }
    case GET_COURSE_SYLLABUS_RESOURCE: {
      return {
        ...state,
        courseSyllabusResource: undefined,
        courseSyllabusResourceLoading: true,
      };
    }
    case GET_COURSE_SYLLABUS_RESOURCE_SUCCESS: {
      return {
        ...state,
        courseSyllabusResource: action.payload,
        courseSyllabusResourceLoading: false,
      };
    }
    case GET_COURSE_SYLLABUS_RESOURCE_FAILED: {
      return {
        ...state,
        courseSyllabusResource: undefined,
        courseSyllabusResourceLoading: false,
      };
    }
    default:
      return state;
  }
};
